<a sd-button class="c__back-button" [isSmall]="true" icon="icon-arrow-left" [routerLink]="['/my-orders']">
  <span>{{ 'order.return.backToMyOrders' | translate }}</span>
</a>
<sd-title [titleLevel]="1" customClass="brand--h4 is-regular">
  {{ 'order.return.returnProductsTitle' | translate }}
</sd-title>
@if (products?.length > 0 && !!returnReasons) {
  <sd-order-return [orderProducts]="products"
    [returnListConfig]="returnReasons"
    [titleLevel]="2"
    [canReturnProduct]="submitted"
    (productSelectedDetails)="returnDetails($event)"
    (printTicket)="printReturnTicket()"
    (printDetails)="printReturnDocument()"
    (openRecommendedPriceModal)="onOpenRecommendedPriceModal()"
  />
}
